/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseOnboardingJourney } from '../models/api-response-onboarding-journey';
import { journey } from '../fn/onboarding-event-admin-api/journey';
import { Journey$Params } from '../fn/onboarding-event-admin-api/journey';

@Injectable({ providedIn: 'root' })
export class OnboardingEventAdminApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `journey()` */
  static readonly JourneyPath = '/v1/api/admin-ui/onboarding-event/{companyReference}/journey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `journey()` instead.
   *
   * This method doesn't expect any request body.
   */
  journey$Response(params: Journey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOnboardingJourney>> {
    return journey(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `journey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  journey(params: Journey$Params, context?: HttpContext): Observable<ApiResponseOnboardingJourney> {
    return this.journey$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOnboardingJourney>): ApiResponseOnboardingJourney => r.body)
    );
  }

}
